import {useEffect, useState} from "react";
import {getCmsPage, type CmsPage} from "@corporatesclub/shared";
import {InfoPageHero} from "./InfoPageHero";

export function CmsPageView({slug}: {slug: string}) {
  const [page, setPage] = useState<CmsPage | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    setPage(null);
    setError("");
    getCmsPage(slug).then(setPage).catch((e: Error) => setError(e.message));
  }, [slug]);
  if(error) {
    return (
      <div className="cc-infoPage cc-cms">
        <div className="cc-infoPage__container">
          <p className="cc-cms__alert cc-cms__alert--err" role="alert">{error}</p>
        </div>
      </div>
    );
  }
  if(!page) {
    return (
      <div className="cc-infoPage cc-cms cc-cms--loading" aria-busy="true">
        <div className="cc-infoPage__hero--sk" />
        <div className="cc-cms__bodySk">
          {Array.from({length: 4}).map((_, i) => <div key={i} className="cc-cms__lineSk" />)}
        </div>
      </div>
    );
  }
  return (
    <article className="cc-infoPage cc-cms">
      <InfoPageHero title={page.title} />
      <div className="cc-infoPage__container">
        <div className="cc-cms__prose" dangerouslySetInnerHTML={{__html: page.content}} />
      </div>
    </article>
  );
}
